import { Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { Layout } from './components/layout/Layout'
import { LoginPage } from './pages/LoginPage'
import { DashboardPage } from './pages/DashboardPage'
import { UsersPage } from './pages/UsersPage'
import { ArchivePage } from './pages/ArchivePage'
import { ReportsPage } from './pages/ReportsPage'
import { TrainingDetailsPage } from './pages/TrainingDetailsPage'
import { ProtectedRoute } from './components/auth/ProtectedRoute'
import { ErrorBoundary } from './components/ErrorBoundary'
import { DatabaseInit } from './components/DatabaseInit'
import { Toaster } from 'react-hot-toast'

function App() {
  return (
    <ErrorBoundary>
      <DatabaseInit>
        <AuthProvider>
          <div className="min-h-screen bg-gray-50">
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <Routes>
                        <Route path="/" element={<DashboardPage />} />
                        <Route path="/users" element={<UsersPage />} />
                        <Route path="/archive" element={<ArchivePage />} />
                        <Route path="/reports" element={<ReportsPage />} />
                        <Route path="/training/:id" element={<TrainingDetailsPage />} />
                        <Route path="/training/:id/attendance" element={<TrainingDetailsPage />} />
                      </Routes>
                    </Layout>
                  </ProtectedRoute>
                }
              />
            </Routes>
            <Toaster position="top-right" />
          </div>
        </AuthProvider>
      </DatabaseInit>
    </ErrorBoundary>
  )
}

export default App
